/**
 * 数值夹逼
 */
export function clamp(num, min, max) {
  var ret = num;

  if (min !== undefined) {
    ret = Math.max(num, min);
  }

  if (max !== undefined) {
    ret = Math.min(ret, max);
  }

  return ret;
}